import React from 'react';
import { Redirect } from 'react-router';
import Quote from '../../QuotesPage/Quote/quote';
import PropTypes from 'prop-types';

const NOT_SELECTED = -1;

export class QuotesForm extends React.Component {
  state = {
    selectedQuoteIndex: NOT_SELECTED
  };

  handleQuoteSelectionChange = (event) => {
    this.setState({ selectedQuoteIndex: Number(event.target.value) });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const quote = this.props.quotes[this.state.selectedQuoteIndex];
    if (this.state.selectedQuoteIndex === NOT_SELECTED) {
      this.props.displayErrors([{ description: 'Please make a selection' }]);
    } else {
      this.props.onSubmit(quote);
      this.setState({ submitSucceeded: true });
    }
  };

  render() {
    if (this.state.submitSucceeded) {
      return <Redirect push to="/apply/loan/submit" />;
    }
    return (
      <form onSubmit={this.handleSubmit} noValidate>
        <fieldset>
          <legend className="cyr-step-header-text">
            <p ref={this.props.focusableRef} tabIndex="-1" className="styled-p">Select the term and APR that’s right for you.</p>
            { this.props.cl_update_disclosure_and_header_for_cyl_eligible && this.props.cylEligible ?
              <p className="offers-disclosure">
                <small>
                    Note: If you apply now, we'll hold the rates listed below while your application is being processed. Final loan
                    approval will be determined after you complete the rest of your application.
                </small>
              </p>
              :
              <p className="offers-disclosure">
                <small>
                    Note: We will hold the below rates for you while your application is processed if you apply now.
                    Approval and the amount of the loan will be determined after you complete the rest of your
                    application.
                </small>
              </p>
            }
          </legend>
          <ol className="quotes">
            { this.props.quotes.map((quote, index) => (
              <li key={index} className="styled-li">
                <Quote quote={quote} index={index} onChange={this.handleQuoteSelectionChange}/>
              </li>
            ))}
          </ol>
        </fieldset>
        <p>
          <button type="submit">Continue</button>
        </p>
      </form>
    );
  }
}

QuotesForm.propTypes = {
  quotes: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  displayErrors: PropTypes.func.isRequired,
  cl_update_disclosure_and_header_for_cyl_eligible: PropTypes.bool,
  cylEligible: PropTypes.bool
};

export default QuotesForm;
